import api from '@/apis/di/budgetSourceAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Chương
export const useBudgetSourceComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetSourceComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'budget_source_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let ors1 = [{ Field: 'is_parent', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: ors1 },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',default_method_distribute_type,group_property_type,budget_source_id';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // func call api lấy dữ liệu combo
  // nthien4 15.07.2022: bổ sung thêm callbackFun để overr dữ liệu trong combo
  const onBudgetSourceComboboxLoadAllData = (payload, row, column, customData) => {
    payload.sort = 'budget_source_code';
    payload.columns = 'budget_source_name,budget_source_id,budget_source_code,parent_id,is_parent,inactive';
    payload.take = 3000;
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // func call api lấy dữ liệu combo
  // nthien4 15.07.2022: bổ sung thêm callbackFun để overr dữ liệu trong combo
  // DVMINH 23/06/2023 Sửa lại filter truyền xuống backend lấy nguồn nếu đang phân quyền theo nguồn khoản
  const onBudgetSourceComboboxLoadAllActiveData = (payload, row, column, customData) => {
    let isHaveBudgetPermission = proxy.$store.state.context.Context.IsBudgetPermission;
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    if(isHaveBudgetPermission){
      extend.push({ Field: 'is_parent', Operator: 'NULL', Ors: [{ Field: 'is_parent', Value: false}] });
    }
    payload.sort = 'budget_source_code';
    payload.columns =
      'budget_source_name,budget_source_id,budget_source_code,parent_id,is_parent,inactive,budget_source_property_id';
    payload.filter = extendFilter(payload.filter, extend);
      payload.take = 3000;
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);

  };

  // config columns combo
  const budgetSourceComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã nguồn',
        dataField: 'budget_source_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nguồn',
        dataField: 'budget_source_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_source_name',
    valueField: 'budget_source_id',
    queryMode: 'remote',
    quickSearch: 'BudgetSourceQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    dropdownWidth: 600,
    comboboxLoadData: onBudgetSourceComboboxLoadData,
  };

  return {
    budgetSourceComboConfig,
    onBudgetSourceComboboxLoadData, // trả về thêm để dùng chung cho cả combo ko thuộc grid
    onBudgetSourceComboboxLoadAllData,
    onBudgetSourceComboboxLoadAllActiveData,
  };
};
